export default {
	base: {
		modal: {
			ok: 'OK',
			cancel: 'Cancel'
		},
		install: {
			title: "Install IDICARE",
			message: "Install this application on your home screen for quick and easy access when you're on the go.",
			buttons: {
				later: 'Later',
				install: 'Install Now'
			}
		},
		idicare: {
			slogan_1: "Health Aid Technologies",
			slogan_2: "We care about your health",
		},
		general: {
			dashboard: "Dashboard",
			// groups
			group: "Group",
			groups: "Groups",
			// devices
			device: "Device",
			devices: "Devices",
			// patients
			patient: "Patient",
			patients: "Patients",
			no_patients: "No patients",
			see_all_patients: "See all patients",
			next_appointment: "Next appointment",
			next_birthday: "Next birthday",
			// alerts
			alerts: "Alerts",
			no_alerts: "No alerts",
			see_all_alerts: "See all alerts",
			// user
			user_account: "Account",
			// profile
			profile: "Profile",
			user_profile: "User profile",
			your_profile: "Your profile",
			no_results: "No results found",
		},
		auth: {
			login: "Login",
			logout: "Logout",
			signup: "Signup",
			register: "Create account",
			already_registered: "Don't you already have an account?",
			no_account: "Don't have an account?",
			forgot_password: "Forgot your password?",

			or: "or",
			you_are_logged_out: "You are logged out",
			account_activation: "Account activation",
			recover_password: "Recover password",
			request_new_password: "Request new password",
			request: "Request",
			confirm: "Confirm",
			back: "Back",
			msg_use_policy: "I confirm that I am 16 years or older and I consent to IDICARE processing my personal data in order to send personalized marketing material in accordance with the",
			msg_privacy_policy: "I was able to read and understand the information on the use of my personal data explained in the"
		},
		account: {
			change_account: "Change account",
			accounts: "Accounts",
		},
		watch: {
			biometric: "Biometric Data",
			geofencing: "Geo Fencing",
			current_location: "Current location",
			pillbox: "Pill Box",
			medication: "Medication Intake",
			no_medication_today: "There is no medication for today",
			appointments: "Appointments",
			no_appointments_today: "No appointments for today",
			healthreports: "Health Reports",
			medicaldocs: "Medical Documents",
			profile: "Patient Profile",
			chat: "Chat",
			personal_information: "Personal Information",
			timeline: "Time Line",
			no_events: "No events found",
		},
		profile: {
			account_information: "Account Information",
			payment_methods: "Payment Methods",
			current_plan: "Current Plan",
			pro_plan: "PRO Plan",
			notifications: "Notifications",
			organizations: "Organizations",
			staff: "Staff",
			synchronization: "Synchronization",
			// account information
			information: "Information",
			change_name: "Change name",
			change_email: "Change email",
			change_password: "Change password",
			change_picture: "Change picture",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/base/base_en-gb.js